import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="flex flex-col gap-4 max-w-md">
            <Link to="/" className="font-heading text-2xl font-bold text-background-50">
              {siteConfig.name}
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteConfig.description}
            </p>
            <div className="flex items-center gap-4">
              <a href={siteConfig.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-foreground-200">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href={siteConfig.socialLinks.douyin} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-foreground-200">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-foreground-200 cursor-pointer" title={`微信号: ${siteConfig.socialLinks.wechat}`}>
                <i className="ri-wechat-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">爆料分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                联系我们
              </Link>
              <span className="text-sm text-foreground-400">邮箱：{siteConfig.email}</span>
              <span className="text-sm text-foreground-400">电话：{siteConfig.phone}</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">友情链接</h4>
            <div className="flex flex-col gap-2">
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">娱乐头条</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">明星八卦网</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">影视圈内参</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {siteConfig.foundingYear} - {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供娱乐参考，不构成任何投资或决策建议
          </p>
        </div>
      </div>
    </footer>
  );
}